module.exports = __webpack_public_path__ + "static/media/icon_questioner_big.d765abcd.svg";